/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserHistoryAddInboxMessagesRead
 */
export interface UserHistoryAddInboxMessagesRead {
    /**
     * 
     * @type {string}
     * @memberof UserHistoryAddInboxMessagesRead
     */
    user_history_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryAddInboxMessagesRead
     */
    read_inbox_message_name: string;
}

/**
 * Check if a given object implements the UserHistoryAddInboxMessagesRead interface.
 */
export function instanceOfUserHistoryAddInboxMessagesRead(value: object): value is UserHistoryAddInboxMessagesRead {
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    if (!('read_inbox_message_name' in value) || value['read_inbox_message_name'] === undefined) return false;
    return true;
}

export function UserHistoryAddInboxMessagesReadFromJSON(json: any): UserHistoryAddInboxMessagesRead {
    return UserHistoryAddInboxMessagesReadFromJSONTyped(json, false);
}

export function UserHistoryAddInboxMessagesReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHistoryAddInboxMessagesRead {
    if (json == null) {
        return json;
    }
    return {
        
        'user_history_azure_id': json['user_history_azure_id'],
        'read_inbox_message_name': json['read_inbox_message_name'],
    };
}

export function UserHistoryAddInboxMessagesReadToJSON(json: any): UserHistoryAddInboxMessagesRead {
    return UserHistoryAddInboxMessagesReadToJSONTyped(json, false);
}

export function UserHistoryAddInboxMessagesReadToJSONTyped(value?: UserHistoryAddInboxMessagesRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_history_azure_id': value['user_history_azure_id'],
        'read_inbox_message_name': value['read_inbox_message_name'],
    };
}

